import * as React from 'react';
import { Search, SearchProps } from '@ixicare/ui';
import { ScanButton } from './ScanButton';
import { ScannerModal, ScanResult } from './ScannerModal';
import styles from './ScanButton.module.css';

interface ScannableSearchProps extends SearchProps {
  onScan: (result: ScanResult) => void;
  scanHint?: string;
}

/**
 * An @ixicare/ui Search with a scanner button. Search has no adornment slot,
 * but its own icon sits on the left, so the button is overlaid on the right.
 */
export const ScannableSearch: React.FC<ScannableSearchProps> = ({ onScan, scanHint, ...searchProps }) => {
  const [isScanning, setIsScanning] = React.useState(false);

  return (
    <>
      <div className={styles.searchWrap}>
        <Search {...searchProps} />
        <ScanButton onClick={() => setIsScanning(true)} />
      </div>
      {isScanning && <ScannerModal onClose={() => setIsScanning(false)} onScan={onScan} hint={scanHint} />}
    </>
  );
};
